module.exports = __webpack_public_path__ + "static/media/profile_grey.bd47fe18.svg";